module.exports = __webpack_public_path__ + "index-banner.png?aabdba8cd8ca8f08e9ede7af40349348";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-banner.png
// module id = 86
// module chunks = 0